// Detect pre-rendering (Puppeteer sets window.__PRERENDERING__ = true).
// During pre-rendering, skip animations so the captured HTML
// matches React's initial render state and avoids hydration mismatches.
// This does NOT match Lighthouse's HeadlessChromium, only actual pre-rendering.
export const isPrerendering = typeof window !== 'undefined' &&
  window.__PRERENDERING__ === true;
